import { useEffect, useLayoutEffect, useRef } from 'react';

export function useScrollTop() {
  const componentRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto',
    });

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    const scrollableElements = document.querySelectorAll('.overflow-y-scroll, .overflow-auto');
    scrollableElements.forEach((el) => {
      if (el instanceof HTMLElement) {
        el.scrollTop = 0;
      }
    });

    const scrollAttempts = [0, 50, 100, 200];
    scrollAttempts.forEach((delay) => {
      setTimeout(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }, delay);
    });

    return () => {};
  }, []);

  useEffect(() => {
    if (componentRef.current) {
      componentRef.current.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }, []);

  return { componentRef };
}
